module.exports = __webpack_public_path__ + "img/subs-baking.a36e103e.png";